import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "dot"]
  static values  = {
    current:  { type: Number, default: 0 },
    interval: { type: Number, default: 4500 }
  }

  connect() {
    this._update()
    if (this.slideTargets.length > 1) this._startTimer()
  }

  disconnect() {
    this._stopTimer()
  }

  goto(event) {
    this._stopTimer()
    this.currentValue = Number(event.currentTarget.dataset.index)
    this._startTimer()
  }

  currentValueChanged() {
    this._update()
  }

  _advance() {
    this.currentValue = (this.currentValue + 1) % this.slideTargets.length
  }

  _startTimer() {
    this.timer = setInterval(() => this._advance(), this.intervalValue)
  }

  _stopTimer() {
    clearInterval(this.timer)
  }

  _update() {
    this.slideTargets.forEach((el, i) => {
      el.classList.toggle("opacity-0", i !== this.currentValue)
    })
    this.dotTargets.forEach((el, i) => {
      el.classList.toggle("w-6",         i === this.currentValue)
      el.classList.toggle("w-2",         i !== this.currentValue)
      el.classList.toggle("opacity-100", i === this.currentValue)
      el.classList.toggle("opacity-40",  i !== this.currentValue)
    })
  }
}
